import React from 'react';
import styled from 'styled-components';
import StyledSliderItem from './SliderItem.style';

const VideoTitle = styled.h2`
color: #FFFFFF;
padding: 15px 0;
font-size: 2vw;
white-space:nowrap;
@media only screen and (max-width: 1100px) {
font-size: 3.5vw;
}
`;

const videoStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
};

const VideoItemMobile = React.forwardRef(({ video }, ref) => (
  <div ref={ref}>
    <VideoTitle>
      {video.title}
    </VideoTitle>
    <StyledSliderItem>
      <iframe
        src={`https://player.vimeo.com/video/${video.id}?byline=0&portrait=0`}
        style={videoStyle}
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen
        title={video.title}
      />
    </StyledSliderItem>
  </div>
));

export default VideoItemMobile;
